/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_History_Signup_To_CheckoutInputs */

const en_admin_funnel_history_signup_to_checkout = /** @type {(inputs: Admin_Funnel_History_Signup_To_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-up → checkout`)
};

/**
* | output |
* | --- |
* | "Sign-up → checkout" |
*
* @param {Admin_Funnel_History_Signup_To_CheckoutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_signup_to_checkout = /** @type {((inputs?: Admin_Funnel_History_Signup_To_CheckoutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_Signup_To_CheckoutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_signup_to_checkout(inputs)
});
export { admin_funnel_history_signup_to_checkout as "admin.funnel.history.signup_to_checkout" }